<div class="assistant-header-line">
  <div class="assistant-created-by" *ngIf="assistant?.modifiedAt">
    <div>
      <u-icon [model]="{ type: 'font', value: 'icon-clock' }" [styles]="{ fontSize: '12px' }"></u-icon>
      <div class="text" [pTooltip]="fullDetails" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">
        {{ startModifiedPhrase }} {{ preDisplayModifiedTime }} this {{ displayModifiedTime }}
      </div>
    </div>
  </div>
  <div class="header-btns-container">
    <avatar-list
      class="avatar-list"
      *ngIf="assistant?.isShared && avatarsList?.length > 0"
      [model]="avatarsList"
      tooltipHeader="SHARED WITH"
      [spreadAvatarsCount]="3"
      [tooltipLimit]="99"
      [sizeAvatarTooltip]="'16px'"
    ></avatar-list>

    <ng-container *ngIf="!assistant.readOnly">
      <u-button
        *ngIf="assistant?.isShared"
        class="no-border-button share-button"
        label="Share"
        type="secondary"
        elementSize="very-small"
        [disabled]="!assistant?.shareOptions"
        (onClick)="onShareClick()"
      ></u-button>

      <u-button
        *ngIf="!assistant?.isShared"
        class="no-border-button share-button"
        label="Share"
        type="secondary"
        [fontIcon]="'lock'"
        elementSize="very-small"
        (onClick)="onShareClick()"
        (mouseover)="op.show($event, actualTarget)"
        (mouseleave)="onHidePanel(op)"
      >
        <p-overlayPanel #op [showTransitionOptions]="'0.2s'" [hideTransitionOptions]="'0ms'">
          <div class="share-tooltip">
            <div class="share-tooltip-title tooltip-main-color">Only You have access</div>
            <div class="share-tooltip-subtitle tooltip-secondary-color">Click to share with your team</div>
          </div>
        </p-overlayPanel>
      </u-button>

      <u-button
        *ngIf="experiencesWithEditMode.includes(assistant?.experienceType)"
        class="header-icon icon-button-clean"
        elementSize="small"
        [fontIcon]="'delete'"
        type="secondary"
        [styles]="{ fontSize: '12px' }"
        debounceClick
        (debounceClick)="onDeleteClick()"
        tooltipPosition="bottom"
        [pTooltip]="'Delete'"
        tooltipStyleClass="u-tooltip"
      ></u-button>
    </ng-container>
  </div>
</div>
